import { css, keyframes } from 'emotion';

const flashing = keyframes`
  0% {opacity:1.0;}
  25% {opacity:0.6;}
  50% {opacity:0.4;}
  75% {opacity:0.6;}
  100% {opacity:1.0;}
`;

export const flashingButton = css({
  animationName: flashing,
  animationDuration: '1s',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
});
